import React from 'react';
import get from 'get-value';
import { Form } from 'antd';

export const shouldUpdateDependency = name => (prevValues, curValues) => get(prevValues, name) !== get(curValues, name);

const FormDependency = ({ name, show, children }) => (
  <Form.Item noStyle shouldUpdate={shouldUpdateDependency(name)}>
    {({ getFieldValue }) => (show(getFieldValue(name)) ? children : null)}
  </Form.Item>
);

export default FormDependency;
